<template>
  <div>
    <BasePolygon
      v-for="(boundary, index) in boundaries"
      :boundary="boundary.coordinates[0].map(getLatLng)"
      :key="'boundary-' + index"
      :popup="popup"
      :tooltip="tooltip"
      @click="onClick"
      />
  </div>
</template>

<script>
import { BasePolygon } from "@/components/Map";

export default {
  name: "BasePolygonGroup",
  components: {
    BasePolygon,
  },
  props: {
    boundaries: {
      type: [Array],
      required: true
    },
    popup: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: true
    },
  },
  methods: {
    // Convert MongoDB GeoJSON to LatLng
    getLatLng: function(coordinates) {
      return [coordinates[1], coordinates[0]];
    },
    onClick() {
      this.$emit('click');
    },
  }
}
</script>

<style>
</style>
